import { createContext, useContext } from "react";

// Bridges the records-review processing card's own close (✕) control to the
// `cardExpanded` toggle that lives in DashboardRunReportReview. The card is
// handed down as an opaque ReactNode, so the collapse handler can't be prop-
// drilled into it — the embedded collapsible wraps the card in this provider,
// and CompletedRecordsView reads it to render the header ✕. Standalone card
// renders have no provider, so no close control appears.
export const ProcessingCardCollapseContext = createContext<(() => void) | null>(
  null,
);

export const useProcessingCardCollapse = (): (() => void) | null =>
  useContext(ProcessingCardCollapseContext);
